import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Breadcrumb } from 'react-breadcrumbs'
import { withRouter } from 'react-router-dom'
import PinUserIcon from 'Assets/Images/icons/pinUser'
import { getCityLink } from 'Utils/Link'
import { PATHS } from 'Config/Routing/paths'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import { AmbassadorWrapper } from 'Components/City/Page/Ambassador/AmbassadorWrapper'
import { Breadcrumbs } from 'Components/Breadcrumbs'
import { PageTitle } from 'Components/PageTitle'
import * as CONST from 'Reducers/Ambassador/const'
import { getAmbassadorDocumentsById } from './../../../../../Reducers/Ambassador/actions'
import { getCities } from 'Reducers/City/actions'
import { getClients } from 'Reducers/Clients/actions'
import LegalDocumentsSection from '../../Ambasador/Components/LegalDocumentsSection/container/LegalDocumentsSection'
import ContactDetailsSection from '../Components/ContactDetailsSection'
import IdentificationFilesSection from '../Components/IdentificationFilesSection'
import ActivitySection from '../Components/ActivitySection'
import BankDetailsSection from '../Components/BankDetailsSection'
import { updateAmbassadorByIdGraphQL } from '../../../../../Reducers/Ambassador/actions'
import { getSpy, getSpyActivity } from '../gql'
import { normalizeGraphQLConnection } from '../../../../../shared/graphql/utils'
import {
  hideReduxModal,
  resetReduxModal,
  showReduxModal,
} from '../../../../../Reducers/UI/actions'
import { deleteSpyShift } from '../../MasterSchedule/gql'
import { Box } from '@material-ui/core'
import useGraphQLFetch from '../../../../../Utils/Hooks/useGraphQLFetch'

const SpyPage = props => {
  const { match } = props
  const {
    url,
    params: { spyId },
  } = match

  const [missions, setMissions] = useState([])
  const [isMissionsLoaded, setIsMissionsLoaded] = useState(false)

  const dispatch = useDispatch()
  const ambassadorDocuments = useSelector(
    state => state.ambassadors.ambassadorDocumentsById,
  )

  const cities = useSelector(state => state.city.citiesList)

  const { data: spy, refetch } = useGraphQLFetch({
    fetchFn: getSpy,
    defaultFetchArgs: { id: spyId },
    mapResponse: data => {
      data.spy.signedLegalDocuments = data.spy.signedLegalDocuments.edges.map(
        e => ({
          dateTime: e.node.dateTime,
          name: e.node.legalDocument.name,
          url: e.node.legalDocument.url,
        }),
      )

      return data.spy
    },
  })

  useEffect(() => {
    getSpyActivities()
    dispatch(getCities(true))
    dispatch(getClients())

    dispatch(getAmbassadorDocumentsById(spyId))
  }, [])

  const getSpyActivities = async () => {
    setIsMissionsLoaded(false)
    setMissions([])
    let fetchArgs = { spyId, first: 50 }
    const { data } = await getSpyActivity(fetchArgs)

    let spyActivities = normalizeGraphQLConnection(data.spy.missions)
    let pageInfo = data.spy.missions.pageInfo
    while (pageInfo.hasNextPage) {
      fetchArgs.after = pageInfo.endCursor
      const { data: newData } = await getSpyActivity(fetchArgs)
      pageInfo = newData.spy.missions.pageInfo

      spyActivities = [
        ...spyActivities,
        ...normalizeGraphQLConnection(newData.spy.missions),
      ]
    }

    setMissions(spyActivities)
    setIsMissionsLoaded(true)
  }

  const statusHTML = () => {
    let statusID = status

    if (!spy) {
      return null
    }

    return (
      status && (
        <span className="status">
          ({CONST.AMBASSADOR_STATUS_LABEL[statusID]})
        </span>
      )
    )
  }

  if (!spy) {
    return null
  }

  const { id, city, firstName, lastName, status, isNewcomer } = spy

  const userName = `${firstName} ${lastName}`
  const cityPathname = getCityLink(city)
  const spyPathname = `${PATHS.main.dashboard}${PATHS.dashboard.cities}/${
    city.id
  }/spy`

  async function handleUserActions({ status, blockedReason, unbookMissions }) {
    await dispatch(
      updateAmbassadorByIdGraphQL(
        spyId,
        {
          statusV2: status,
          blockedReason,
          unbookMissions,
        },
        {
          onSuccess: () => {
            refetch({ id: spyId })
            if (unbookMissions) {
              getSpyActivities()
            }
          },
        },
      ),
    )
  }

  const deleteMission = mission => {
    dispatch(
      showReduxModal({
        title: 'Confirmation needed',
        children: (
          <Box
            display="flex"
            flexWrap="wrap"
            justifyContent="center"
            mt={3}
            mb={3}
          >
            Spy will be removed from the whole shift
          </Box>
        ),
        onConfirm: async () => {
          try {
            await deleteSpyShift({
              id: mission.spyInformation.shift.id,
            })

            await getSpyActivities()
            hideReduxModal()
            resetReduxModal()
          } catch (error) {
            alert(`Error occured: ${error.message}`)
          }
        },
        onCancel: () => {
          hideReduxModal()
          resetReduxModal()
        },
      }),
    )
  }

  if (!id) return null

  return (
    <HideWhenBlocked>
      <AmbassadorWrapper>
        <Breadcrumbs icon={<PinUserIcon style={{ width: 16 }} />} />
        <Breadcrumb
          data={{ title: 'Dashboard', pathname: `${PATHS.main.dashboard}` }}
        />
        <Breadcrumb
          data={{
            title: 'Cities',
            pathname: `${PATHS.main.dashboard}${PATHS.dashboard.cities}`,
          }}
        />
        <Breadcrumb data={{ title: city.name, pathname: cityPathname }} />
        <Breadcrumb data={{ title: 'Spy', pathname: spyPathname }} />
        <Breadcrumb
          data={{
            title: firstName + ' ' + lastName,
            pathname: url,
          }}
        />
        <PageTitle>
          {userName}
          {statusHTML()}
          {isNewcomer && (
            <div
              style={{ float: 'right', lineHeight: '34px', fontSize: '16px' }}
            >
              <span role="img" aria-label="warning">
                ⚠️
              </span>
              Newcomer
              <span role="img" aria-label="warning">
                ⚠️
              </span>
            </div>
          )}
        </PageTitle>
        <div>
          <ContactDetailsSection
            ambassadorId={spyId}
            ambassador={spy}
            cities={cities}
          />
          <IdentificationFilesSection
            ambassador={spy}
            ambassadorDocuments={ambassadorDocuments}
            cities={cities}
            handleUserActions={handleUserActions}
          />
          <BankDetailsSection ambassador={spy} />
          <LegalDocumentsSection
            signedLegalDocuments={spy.signedLegalDocuments || []}
            formW9={spy.formW9}
          />
          <ActivitySection
            match={match}
            missions={missions}
            isLoaded={isMissionsLoaded}
            deleteMission={deleteMission}
          />
        </div>
      </AmbassadorWrapper>
    </HideWhenBlocked>
  )
}

export default withRouter(SpyPage)



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Spies/View/index.js